import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Input from '../../Input';

const LessonEditDataVideo = ({ data = '', onChange = () => {} }) => {
  const [url, setUrl] = useState(data);

  useEffect(() => {
    setUrl(data);
  }, [data]);

  useEffect(() => {
    onChange({ data: url });
  }, [url, onChange]);

  return (
    <Container>
      <Input
        placeholder='Youtube Video URL'
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
    </Container>
  );
};

const Container = styled.div``;

export default LessonEditDataVideo;
